import { render, staticRenderFns } from "./PlayersMarkets.vue?vue&type=template&id=21503207&"
import script from "./PlayersMarkets.vue?vue&type=script&lang=js&"
export * from "./PlayersMarkets.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports